<template>
  <div id="page-forum-page">
    <ForumPostTable />
  </div>
</template>

<script>
import axios from 'axios';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { mapGetters } from 'vuex';
import ForumPostTable from '@/view/pages/ml/forum/ForumPostTable.vue';


export default {
  name: 'ForumPage',
  mixins: [ toasts ],
  components: {
    ForumPostTable
  },
  computed: {
    // which stored data we want to use
    ...mapGetters(['currentCompanyId', 'currentPeriodId', 'settings'])
  },
  mounted() {
    //this.example = this.examples[0];
  },
  data() {
    return {
      selected_history: null
    };
  },
  watch: {
    currentCompanyId() {
      // triggers when user has changed company on top
      // we should reload content based on selected company
    },
    currentPeriodId() {
      // triggers when user has changed period on top
      // we should reload content based on period
    }

  },
  methods: {

  }
};
</script>
